import request from "@/router/axios";

// 平台还款
export const platformRepaymentPage = (current, size, params, search) => {
  return request({
    url: `/api/blade-PlatformRepayment/PlatformRepayment/page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

export const platformRepaymentDetail = (platformRepaymentId) => {
  return request({
    url: `/api/blade-PlatformRepayment/PlatformRepayment/getdetail`,
    method: "post",
    data: {
      platformRepaymentId
    },
  });
};

// 修改平台还款
export const updateData = (data) => {
  return request({
    url: `/api/blade-PlatformRepayment/PlatformRepayment/updateData`,
    method: "post",
    data: data,
  });
};

// 还款计划
export const platfomRepaymentPlanPage = (current, size, params) => {
  return request({
    url: `/api/blade-PlatfomRepaymentPlan/PlatfomRepaymentPlan/page`,
    method: "post",
    data: {
      current,
      size,
      ...params
    },
  });
};

// 查询平台还款计划列表期数 总期数 应还金额
export const platfromPlanAmountList = (auditPlatformRepaymentId) => {
  return request({
    url: `/api/blade-PlatfomRepaymentPlan/PlatfomRepaymentPlan/platfromPlanAmountList`,
    method: "get",
    params: {
      auditPlatformRepaymentId
    },
  });
};

// 确认还款
export const submitReplaymentPlan = (data) => {
  return request({
    url: `/api/blade-PlatfomRepaymentPlan/PlatfomRepaymentPlan/submitReplaymentPlan`,
    method: "post",
    data: data,
  });
};

// 表格导出
export const exportPlatformRepayment = (data) => {
  return request({
    url: `/api/blade-PlatformRepayment/PlatformRepayment/export-PlatformRepayment`,
    method: "post",
    responseType: 'blob',
    data: data,
  });
};
